<app-header></app-header>
<ion-content scroll-y="false">
  <div #mainDivScroll class="container">
    <ng-container *ngIf="vm$ | async; let vm">
      <ion-header class="payment-confirmation" data-cy="payment-confirmation">
        <ion-grid>
          <ion-row
            *ngIf="platformService?.platformType === platformService?.platformEnum.desktop"
          >
            <ion-col class="header-top" size="12">
              <app-breadcrumbs [breadcrumbs]="vm.breadcrumbs"></app-breadcrumbs>
              <ng-container
                [ngTemplateOutlet]="sharePrintDownloadOpt"
                [ngTemplateOutletContext]="{isDesktop: platformService?.platformType === platformService.platformEnum.desktop, shareFlag: vm.shareFlag}"
              ></ng-container>
            </ion-col>
          </ion-row>

          <ion-row
            class="header__title-row"
            [ngClass]="{'is-windows': platformService?.isWindows(), 'is-tablet': platformService?.platformType === platformService?.platformEnum.tablet }"
          >
            <ion-col size="12">
              <div class="title-container">
                <h1 class="page-title-oswald" data-cy="title-text">
                  {{ pageText.title }}
                </h1>
                <ng-container
                  *ngIf="platformService?.isTouchExperience$ | async"
                  [ngTemplateOutlet]="sharePrintDownloadOpt"
                  [ngTemplateOutletContext]="{isMobile: platformService?.platformType === platformService?.platformEnum.mobile, shareFlag: vm.shareFlag}"
                ></ng-container>
              </div>

              <ng-container *ngIf="vm.isLoading">
                <ion-col
                  class="header-skeleton"
                  data-cy="review-payment-header-skeleton"
                  size-lg="5"
                  size-md="6"
                  size-sm="7"
                  size-xs="7"
                >
                  <ion-skeleton-text animated></ion-skeleton-text>
                  <ion-skeleton-text animated></ion-skeleton-text>
                </ion-col>
              </ng-container>
              <ng-container *ngIf="!vm.isLoading">
                <app-inline-toast
                  *ngIf="!!toast"
                  [toast]="toast"
                  [canDismiss]="false"
                >
                </app-inline-toast>
                <h6 data-cy="payment-confirmation-subtitle">
                  {{'i18n.payments.paymentConfirmation.subtitleText'|
                  translate}}
                  <span>
                    {{(vm.transactionsWithErrors.length > 0 ?
                    'i18n.payments.paymentConfirmation.failedTransactionContactNumber'
                    :'i18n.payments.paymentConfirmation.contactNumber') |
                    translate}}</span
                  >
                </h6>
              </ng-container>
            </ion-col>
          </ion-row>

          <section
            *ngIf="!vm.isLoading"
            class="information-section"
            data-cy="payment-information-section"
          >
            <ion-row
              *ngIf="paymentSummary"
              [ngClass]="{'is-tablet': platformService?.platformType === platformService?.platformEnum.tablet }"
            >
              <ion-col size-lg="4" size-md="5" size-sm="12" size-xs="12">
                <ion-row>
                  <ion-col size="12">
                    <span data-cy="payment-date-label">
                      {{'i18n.payments.paymentConfirmation.paymentDate'|
                      translate}}&nbsp;</span
                    >
                    <span data-cy="payment-date"
                      >{{paymentSummary.paymentDate}}</span
                    >
                  </ion-col>
                </ion-row>
                <ion-row>
                  <ion-col size="12">
                    <span data-cy="payment-status-label">
                      {{'i18n.payments.paymentConfirmation.status'|
                      translate}}&nbsp;</span
                    >
                    <span data-cy="payment-status-value"
                      >{{paymentSummary.status}}</span
                    >
                  </ion-col>
                </ion-row>
                <ion-row>
                  <ion-col size="12">
                    <span data-cy="payment-source-label">
                      {{'i18n.payments.paymentConfirmation.paymentSource'|
                      translate}}&nbsp;</span
                    >
                    <span data-cy="payment-source-value"
                      >{{ vm.overallCustomerBankAccounts.length > 1 ?
                      ('i18n.payments.reviewAndSubmit.multiple' | translate) :
                      (vm.overallCustomerBankAccounts[0].nickName ?
                      vm.overallCustomerBankAccounts[0].nickName :
                      vm.overallCustomerBankAccounts[0].bankName) }}</span
                    >
                  </ion-col>
                </ion-row>
              </ion-col>

              <ion-col size-lg="4" size-md="5" size-sm="12" size-xs="12">
                <ion-row>
                  <ion-col size="12">
                    <span
                      data-cy="customers-amount-label"
                      class="information-title"
                    >
                      {{'i18n.payments.paymentConfirmation.customersAmount'|
                      translate}}&nbsp;</span
                    >
                    <span data-cy="customers-amount-value"
                      >{{paymentSummary.customerAmount}}</span
                    >
                  </ion-col>
                </ion-row>
                <ion-row>
                  <ion-col size="12">
                    <span
                      data-cy="transaction-amount-label"
                      class="information-title"
                    >
                      {{'i18n.payments.paymentConfirmation.transactionsAmount'|
                      translate}}&nbsp;</span
                    >
                    <span data-cy="transaction-amount-value"
                      >{{ paymentSummary.transactionAmount }}</span
                    >
                  </ion-col>
                </ion-row>
                <ion-row *ngIf="vm.transactionsWithErrors.length > 0">
                  <ion-col size="12">
                    <span
                      data-cy="failed-to-submit-label"
                      class="information-title"
                    >
                      {{'i18n.payments.paymentConfirmation.failedToSubmit'|
                      translate}}&nbsp;</span
                    >
                    <span data-cy="transaction-amount-value"
                      >{{ vm.transactionsWithErrors.length }}</span
                    >
                  </ion-col>
                </ion-row>
              </ion-col>
            </ion-row>
          </section>
        </ion-grid>
      </ion-header>

      <div class="gray-content-bg" data-cy="payment-confirmation-content">
        <ion-grid>
          <app-transactions-failed-details
            *ngIf="!vm.isLoading && vm.transactionsWithErrors.length > 0"
            [transactionsFailed]="vm.transactionsWithErrors"
          ></app-transactions-failed-details>
          <app-customer-summary-section
            *ngIf="vm.transactions.length > 0"
            [accordionOpenByDefault]="true"
            [transactions]="vm.transactions"
            [customers]="vm.customers"
            [isLoading]="vm.isLoading"
            [isSubmitted]="true"
            [totalAmount]="vm.totalAmount"
            [showOrderNumber]="vm.showOrderNumber"
          ></app-customer-summary-section>
        </ion-grid>
        <ng-container
          *ngIf="platformService?.platformType === platformService?.platformEnum.mobile && !vm.isLoading"
          [ngTemplateOutlet]="backToPaymentButton"
        ></ng-container>
        <div
          data-cy="payment-confirmation-actions"
          class="payment-confirmation-button"
        >
          <ng-container
            *ngIf="platformService?.platformType !== platformService?.platformEnum.mobile && !vm.isLoading"
            [ngTemplateOutlet]="backToPaymentButton"
          ></ng-container>
          <app-top-button
            [mainScroll]="mainScroll"
            [isMobile]="platformService?.platformType === platformService?.platformEnum.mobile"
          ></app-top-button>
        </div>
      </div>
      <app-footer></app-footer>
    </ng-container>
  </div>
</ion-content>

<ng-template
  #sharePrintDownloadOpt
  let-isMobile="isMobile"
  let-isDesktop="isDesktop"
  let-isTablet="isTablet"
  let-shareFlag="shareFlag"
>
  <app-share-print-download
    [isMobile]="isMobile"
    [showPrint]="isDesktop"
    [showShare]="shareFlag"
    (shareButtonClick)="sharePaymentConfirmation(isDesktop)"
    (printButtonClick)="printPaymentConfirmation()"
    (downloadButtonClick)="downloadPaymentConfirmation()"
    (ellipsisButtonClick)="openMobileActionSheet(shareFlag)"
  ></app-share-print-download>
</ng-template>

<ng-template #backToPaymentButton>
  <div class="back-button">
    <ion-button
      data-cy="back-to-payment-center-button"
      class="usf-fill-green-button"
      (click)="goBackToPaymentCenter()"
    >
      {{ 'i18n.payments.paymentConfirmation.backToPaymentCenter' | translate
      }}&nbsp;
    </ion-button>
  </div>
</ng-template>
